<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          所属机构
        </div>
        <el-select
          v-model="searchForm.agencySearch"
          placeholder="请选择所属机构"
          clearable
          filterable
          @change="getList()"
        >
          <el-option
            v-for="item in agencyList"
            :key="item.id"
            :label="item.value"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          支付方式
        </div>
        <el-select
          v-model="searchForm.payMethod"
          placeholder="请选择支付方式"
          clearable
          filterable
          @change="getList()"
        >
          <el-option
            v-for="item in payMethodList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          是否退款
        </div>
        <el-select
          v-model="searchForm.isRefund"
          placeholder="请选择是否退款"
          clearable
          filterable
          @change="getList()"
        >
          <el-option
            v-for="item in isRefundList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="r">
        <el-select
          v-model="studentSearchType"
          class="input-select"
          placeholder="请选择状态"
          filterable
          clearable
          @change="clearSearchValue"
        >
          <el-option
            v-for="item in processSearchList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input
          v-model="searchForm[studentSearchType]"
          :placeholder="placeholder[studentSearchType]"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-link
          :href="downloadUrl"
          target="_blank"
        >
          <el-button type="primary">
            导出进度列表
          </el-button>
        </el-link>
      </div>
    </div>
    <div class="header">
      <div class="l">
        <div class="label">
          开始时间
        </div>
        <el-date-picker
          v-model="searchForm.createTimeStart"
          type="date"
          placeholder="选择开始时间"
          value-format="timestamp"
          @change="getList()"
        />
        <div class="label">
          结束时间
        </div>
        <el-date-picker
          v-model="searchForm.createTimeEnd"
          type="date"
          placeholder="选择结束时间"
          value-format="timestamp"
          @change="getList()"
        />
        <div class="label">
          报名状态
        </div>
        <el-select
          v-model="searchForm.registrationStatus"
          placeholder="请选择报名状态"
          clearable
          filterable
          @change="getList()"
        >
          <el-option
            v-for="item in registrationStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          代理商
        </div>
        <el-select
          v-model="searchForm.agentId"
          placeholder="请选择状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agentList"
            :key="item.id"
            :label="item.agentName"
            :value="item.id"
          />
        </el-select>
        <div class="label">
          代理商用户
        </div>
        <el-select
          v-model="searchForm.agentUserId"
          placeholder="请选择状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agentUserList"
            :key="item.userId"
            :label="item.showName"
            :value="item.userId"
          />
        </el-select>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :pagination="true"
      :table-column="tableColumn"
      @changeBypagination="tableHandle"
      @sortChange="sortChange"
      @buttonClick="buttonClick"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import {
  processSearchList, payMethodList, isRefundList, registrationStatusList,
} from '@/config';

const config = require('../../../../httpConfig');

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  data() {
    return {
      agencyList: [],
      agentList: [],
      processSearchList,
      payMethodList,
      isRefundList,
      registrationStatusList,
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        agencySearch: '',
        courseSearch: '',
        createTimeStart: '',
        createTimeEnd: '',
        isRefund: '',
        registrationStatus: '',
        agentId: '',
        agentUserId: '',

      },
      tabelData: {},
      studentSearchType: 'userSearch',
      placeholder: {
        userSearch: '学员搜索（姓名，身份证，手机号)',
        courseSearch: '请输入课程名称',
      },
      tableColumn: [
        {
          key: 'realName',
          label: '学员姓名',
          dataType: 'text',
        },
        {
          key: 'wechatNickName',
          label: '微信昵称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '手机',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'idCard',
          label: '身份证',
          width: '160px',
          dataType: 'text',
        },
        {
          key: 'address',
          label: '地址',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agencyName',
          label: '机构名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'chargePersonName',
          label: '机构负责人名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'chargePersonPhone',
          label: '机构负责人电话',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseName',
          label: '课程名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agentName',
          label: '代理商名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agentUserName',
          label: '代理商推广员',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseTypeStr',
          label: '课程类型',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'registrationStatusStr',
          label: '报名状态',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'questionExamStatusStr',
          label: '理论考试状态',
          width: 'auto',

          dataType: 'text',
        },
        {
          key: 'videoExamStatusStr',
          label: '视频考试状态',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'coursePrice',
          label: '课程价格',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'payAmount',
          label: '支付价格',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'payMethodStr',
          label: '支付方式',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'isCanRefundStr',
          label: '是否能退款',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'isRefundStr',
          label: '是否退款',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: '160px',
          dataType: 'time',
        },
        {
          key: 'agencyIsWithdrawStr',
          label: '机构是否已提现',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'liveWatchProgressListStr',
          label: '直播学习进度',
          width: '160px',
          dataType: 'text',
          substr: 10,
        },
      ],
    };
  },
  computed: {
    downloadUrl() {
      let query = 'pageNum=1&pageSize=9999';
      for (const obj in this.searchForm) {
        if (Object.prototype.hasOwnProperty.call(this.searchForm, obj)) {
          if (obj !== 'pageNum' && obj !== 'pageSize') {
            if (this.searchForm[obj] !== '') {
              let value = this.searchForm[obj];
              if (obj === 'createTimeStart' || obj === 'createTimeEnd') {
                value = this.$time(Number(value)).format('YYYY/MM/DD HH:mm:ss');
              }
              query += `&${obj}=${value}`;
            }
          }
        }
      }
      return `${process.env.VUE_APP_HOST_ENV === 'dev' ? config.dev : config.prod}/api/course/registration/progressExcelExportGET?${query}`;
    },
    agentUserList() {
      if (this.searchForm.agentId) {
        if (this.agentList.filter((v) => v.id === this.searchForm.agentId).length > 0) {
          return this.agentList.filter((v) => v.id === this.searchForm.agentId)[0].userList;
        }
      }
      return [];
    },
  },
  created() {
    this.getList();
    this.selectList();
    this.getAgentList();
  },
  mounted() {
    if (this.$route.query.agentId) {
      this.searchForm.agentId = Number(this.$route.query.agentId);
      console.log(this.searchForm.agentId);
    }
    if (this.$route.query.agentUserId) {
      this.searchForm.agentUserId = Number(this.$route.query.agentUserId);
    }
    if (this.$route.query.startTime) {
      this.searchForm.createTimeStart = this.$route.query.startTime;
    }
    if (this.$route.query.endTime) {
      this.searchForm.createTimeEnd = this.$route.query.endTime;
    }
  },
  methods: {
    // 获取列表
    async getAgentList() {
      this.agentList = await axClient.agent.agentListAllName();
    },
    // 切换下拉 清除选项的值
    clearSearchValue() {
      this.searchForm.courseSearch = '';
      this.searchForm.userSearch = '';
    },
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.registration.pageProgress(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    async selectList() {
      this.agencyList = await axClient.registration.listNameByRegistration();
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        createTime: {
          ascending: 10,
          descending: 20,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.openVideoDialog(item);
          break;
        default:
          break;
      }
    },
    openVideoDialog(item) {
      this.vedioVisible = true;
      this.activeVideoItem.url = item.videoUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  .header {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    .l {
      display: flex;
      align-items: center;
      .label {
        font-weight: 500;
        font-size: 14px;
        margin-right: 12px;
        min-width: 50px;
      }
      .el-select,
      .el-date-editor {
        margin-right: 15px;
        flex: 1;
      }
    }
    .r {
      display: flex;
      align-items: center;
      .input-select {
        width: 150px;
        ::v-deep .el-input__inner {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
        & + .el-input {
          width: 80%;
          ::v-deep input {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-left: 0;
          }
        }
      }
      & > .el-button {
        flex: 1;
        margin-left: 15px;
        min-width: auto;
      }
      .el-link {
        margin-left: 15px;
      }
    }
  }
}
</style>
